import React from 'react';
import {ProductQuantityEnum} from "@/constants/commerce-enum";

type TotalQuantityCardComponentProps = { count: number | null };

const TotalQuantityCardComponent = (({count}: TotalQuantityCardComponentProps) => {
    if (!count || count >= 20) return null;

    return (
        <>{count < 10 ? ProductQuantityEnum.lessThen : ProductQuantityEnum.lessTwenty}</>
    );
});

export default React.memo(TotalQuantityCardComponent);
